import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearLastSpotRoute } from '../store/slices/savedSpotsSlice';
import ChevronLeftIcon from '../components/icons/ChevronLeftIcon';

const PageNavSavedLocation = ({id = null}) => {

    const dispatch = useDispatch();

    if(!id){
        return <></>
    }
    
    return (
        <nav>
            <Link
                to="/saved-spots"
                onClick={() => dispatch(clearLastSpotRoute())}
                className='inline-flex items-center gap-1 -ml-1 py-2 pr-3 text-sm font-bold text-custom-light-blue hover:text-custom-light-blue/80 transition-colors'
            >
                <ChevronLeftIcon />
                All Spots
            </Link>
            <ul className='flex justify-center gap-4 sm:gap-6 md:gap-8 sm:justify-start items-center text-xs sm:text-sm mt-1 border-b border-custom-charcoal'>

                <li className=''>
                    <NavLink 
                        to={`/location/${id}/forecast`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Forecast
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to={`/location/${id}/view`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Overview
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to={`/location/${id}/preferences`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Ideal&nbsp;Conditions
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to={`/location/${id}/edit`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Manage
                    </NavLink>
                </li>   
            </ul>
        </nav>
    )
}

export default PageNavSavedLocation;